import { ZoomedWrapper } from 'components/Containers/ImageText.js';
import { HiddenDevOnlyOptions } from 'components/HiddenDevOnlyButton';
import { Text } from 'components/Text';
import Title from 'components/Title';
import { gameStateType } from 'core/constants';
import { addCommasAndAnd, processText } from 'core/utils/string';
import { useTextFlow } from 'hooks';
import React, { useEffect, useState } from 'react';
import { desktop } from 'submodules/sharedText/flavor';

const { INTRO, NIGHT_INTRO, MORNING_INTRO } = gameStateType;

const Intro = ({
  pause,
  gameState,
  onComplete,
  players,
  restartRound,
  restartRoundNoIntro,
}) => {
  // Super fucking hacky
  // Was flashing wrong title
  const [originalGameState, setOriginalGameState] = useState(gameState);
  useEffect(() => {
    if ([INTRO, NIGHT_INTRO, MORNING_INTRO].includes(gameState)) {
      setOriginalGameState(gameState);
    }
  }, [gameState]);

  const { [originalGameState]: flavor } = desktop;
  const playerNames = addCommasAndAnd(players.map(({ userName }) => userName));
  const text = useTextFlow(pause, flavor?.content, { playerNames }, onComplete);
  return (
    <>
      <ZoomedWrapper>
        <Title>{processText(flavor?.title).toLocaleUpperCase()}</Title>
        <Text>{text}</Text>
      </ZoomedWrapper>
      <HiddenDevOnlyOptions
        onComplete={onComplete}
        restartRound={restartRound}
        restartRoundNoIntro={restartRoundNoIntro}
      />
    </>
  );
};

export default Intro;
